import { render, staticRenderFns } from "./Reminders.vue?vue&type=template&id=5facf716&scoped=true&"
import script from "./Reminders.vue?vue&type=script&lang=js&"
export * from "./Reminders.vue?vue&type=script&lang=js&"
import style0 from "./Reminders.vue?vue&type=style&index=0&id=5facf716&prod&lang=scss&"
import style1 from "./Reminders.vue?vue&type=style&index=1&id=5facf716&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5facf716",
  null
  
)

export default component.exports